import React from "react";

import Button from "../Button";
import Dialog from "../Dialog";

import { getAutoModalTimeStamp, setAutoModalTimeStamp } from '../../utils/SettingsRetriever';

import IntlMessage from "../../LocaleEngine";

export default class HelpDialog extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            startup_popup: {
                open: false
            }
        }
    }

    componentDidMount(){
        if (this.props.settings.app && this.props.settings.app.startup_popup && this.props.settings.app.startup_popup.enabled){
            if ( getAutoModalTimeStamp() && ( getAutoModalTimeStamp() + (this.props.settings.app.startup_popup.interval * 1000) < new Date().getTime() ) ) {
                setTimeout( () =>  { 
                    this.triggerAutoModal(this.props.settings.app.startup_popup);
                }, 1000 )
                return;
            } else if ( !getAutoModalTimeStamp() ) {
                setTimeout( () =>  { 
                    this.triggerAutoModal(this.props.settings.app.startup_popup);
                }, this.props.settings.app.startup_popup.seconds * 1000 )
                return;
            }
        }
    }

    triggerAutoModal = ( startup_popup ) => {
        this.setState({ startup_popup: { ...startup_popup, open: true }}, () => {
            setAutoModalTimeStamp(new Date().getTime()); 
        })
    }

    render(){
        return (
            <Dialog
                open={this.state.startup_popup.open}
                className="startup_popup"
                footerContent={ <Button onClick={() => this.setState({ startup_popup: { ...this.state.startup_popup, open: false } })}><IntlMessage id="Got it" /></Button> }
            >
                <div className="body" dangerouslySetInnerHTML={{ __html: this.state.startup_popup.message }} />
            </Dialog>
        )
    }
}